import React from "react";
import MemberMenu from "../components/menu/general/MemberMenu";

const AnggotaIKDKI = () => {
  return <MemberMenu />;
};
export default AnggotaIKDKI;
